import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InspirationRoutingModule } from './inspiration-routing.module';
import { InspirationFormComponent } from './inspiration-form/inspiration-form.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [InspirationFormComponent],
  imports: [
    CommonModule,
    InspirationRoutingModule,
    FormsModule,
    TranslateModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
})
export class InspirationModule {}
